<template>
	<div class="h-full">
				<TopAppBar
			:leftBtnMode="leftBtnMode"
			:rightBtnMode="rightBtnMode"
			:title="title"
			:leftBtnMethod="leftBtnMethod"
			:rightBtnMethod="rightBtnMethod"
			staticMode="true"
		:hideCategory="true"
		></TopAppBar>
		<div class="d-flex h-full flex-column">
					<TopAppBarDrawer></TopAppBarDrawer>
				<main class="main-wrapper flex-grow-1">
						<div class="d-flex align-items-center bg-white">
								<div class="t-headline13 t-color-headlineBlack pda-14 flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center font-m">
										{{$t('3341')}}
								</div>
								<div class="mgr-24 right-button"><button class="mdc-icon-button" 	@click="searchOpen" @keypress="searchOpen" tabindex="0"><i
										class="material-icons ">search</i></button></div>
						<div class="searchbar-with-category bg-white position-absolute w-full" :style="hiding">
								<div class="d-flex align-items-center pdt-8 pdb-8">
												<div class="mgl-12" @click="searchClose();" @keypress="searchClose();" tabindex="0">
													<i class="material-icons mdc-icon-button t-headline6 js--dropdown-toggle"
																				id="search-category-close">close</i>
												</div>
												<div class="flex-grow-1 pdl-12 pdt-4">
																<input type="text" :placeholder="$t('3332')"
																				class="search_form w-full t-color-headlineBlack border-none t-headline8 cursor-blue"
																				autofocus v-model="contents" @keyup="getStoreSerach" />
												</div>
												<div class="mgr-22" @click="search" @keypress="search" tabindex="0">
													<i class="material-icons mdc-icon-button t-headline6 js--dropdown-toggle"
																				id="search-category-close">search</i>
												</div>
								</div>

				</div>
				</div>
						<div class="divider"></div>
						<!-- subtabs -->
					 
						<div class="container container--narrow pdt-24">
								<div class="pdb-4 d-flex" v-if="distributionDetail">
										<div class="mdc-chip-set mdc-chip-set--choice chip--tag-type p-0 pdl-0 checklist-detail-chip">
												<div class="demo-chip mdc-chip bg-lecturePurpleBG16" tabindex="0">
														<!-- <div class="mdc-chip__ripple"></div>        -->
												<div class="mdc-chip__text t-helper font-r t-color-lecturePurple">{{distributionDetail.checklistPaper.hcategory.text}}</div>
												</div>
										</div>
										<div class="mdc-chip-set mdc-chip-set--choice chip--tag-type p-0">
												<div class="demo-chip mdc-chip bg-lectureYellowBG16" tabindex="0">
														<!-- <div class="mdc-chip__ripple"></div>        -->
												<div class="mdc-chip__text t-helper font-r t-color-lectureYellow">{{distributionDetail.checklistPaper.hcategory.child.text}}</div>
												</div>
										</div>        
								
								</div>
								
								<div class="t-headline13 t-line-h-34 l-spacing66 font-m">{{distributionDetail?distributionDetail.name:''}}</div>
								<div class="mgt-16 t-body1 t-color-bodyGrayA l-spacing48 t-line-h-20 font-r">{{distributionDetail?distributionDetail.summary:''}}</div>
								<div class="mgt-18 mgb-32">
										<span class="t-body3 font-r t-color-bodyGrayB">{{$t('3342')}}</span> 
																				<span class="t-color-bodyGrayA font-r t-body3 pdl-8">{{distributionDetail?$moment(distributionDetail.periodPolicy.post.start).format('L'):''}} ~ {{distributionDetail?$moment(distributionDetail.periodPolicy.post.end).format('L'):''}}</span>
								</div>
								
						</div>
						<div class="divider"></div>
						<div class="container container--narrow">
								<div class="d-flex justify-content-between align-items-center pdt-12 mgb--1">
										<div class="t-body3 t-color-bodyGrayA font-r t-line-h-20" v-if="totalElements >  0">{{$t('3343',{str:totalElements})}}</div>
																				<div class="t-body3 t-color-bodyGrayA font-r t-line-h-20" v-else>{{$t('3343',{str:'0'})}}</div>
										<div class="pdl-16 position-relative mdc-menu-anchor menu-container cursor-pointer header-toggle d-flex justify-content-end">
										<button class="mdc-button t-color-bodyGrayA js--dropdown-toggle">
												<div class="mdc-button__ripple"></div>
												<span class="mdc-button__label t-body3 font-r" @click="toggleMenu" @keypress="toggleMenu" tabindex="0">{{menuTypeTitle}}</span>
												<i tabindex="0" class="material-icons mdc-button__icon" aria-hidden="true" @click="toggleMenu" @keypress="toggleMenu">{{showToggle ? 'arrow_drop_up' : 'arrow_drop_down'}}</i>
										</button>
										<div class="mdc-menu mdc-menu-surface toggle-menu" :class="showToggle ? 'mdc-menu-surface--open':''">
												<ul class="mdc-list" role="menu" aria-hidden="true" aria-orientation="vertical" tabindex="0">
														<li class="mdc-list-item" role="menuitem" @click="onSelect('ALL','3344')" @keypress="onSelect('ALL','3344')" tabindex="0">
																<span class="mdc-list-item__ripple"></span>
																<span class="mdc-list-item__text t-body6 font-r">{{$t('3344')}}</span>
														</li>
														<li class="mdc-list-item" role="menuitem" @click="onSelect('SELF','3350')" @keypress="onSelect('SELF','3350')" tabindex="0">
																<span class="mdc-list-item__ripple"></span>
																<span class="mdc-list-item__text t-body6 font-r">{{$t('3350')}}</span>
														</li>
												</ul>
										</div>
										</div>
								</div>
																<div class="process-checklist b-radius4 pdt-16 pdb-8 pdl-16 pdr-16 mgt-15 mgb-8" @click="unsolvedClick" @keypress="unsolvedClick" v-if="exists && exists.activeRespondentPaper && exists.activeRespondentPaper.status === 'SOLVING' && distributionDetail.status.value != 'STOP'" tabindex="0">
										<div class="t-body1 l-spacing42 t-line-h-24 font-r">{{$t('3347')}}</div>
										<div class="mgt-12 mgb-16">
												<span class="t-body4 font-r t-color-bodyGrayB">{{$t('3348')}}</span> <span class="t-color-bodyGrayA font-r t-body4 pdl-8">{{exists  && exists.lastSubmitDate?$moment(exists.lastSubmitDate).format('L') :''}} {{ exists.lastSubmitDate?$moment(exists.lastSubmitDate).format('HH:mm'):''}}</span>
										</div>
										<div class="t-right">
												<button type="button" class="mdc-button  mgr--8" @click.stop="deleteAnswer" @keypress.stop="deleteAnswer" tabindex="0">
														<div class="mdc-button__ripple"></div>
														<span class="mdc-button__label t-color-secondaryBtnText font-r">{{$t('3349')}}</span>
												</button>
										</div>
								</div>
																<div v-for="(checklist, index2) in detail" :key="index2" @click="goToCommentSection(checklist)" @keypress="goToCommentSection(checklist)" tabindex="0">
								<div class="d-flex pdt-24 pdb-24 checklist-detail-list">
										<div class="min-w-58">
												<div class="t-color-contentBlue t-helper t-center font-r t-line-h-16">Score</div>
												<div class="t-headline5 t-line-h-32 t-color-contentBlue t-center font-rb">{{checklist && checklist.totalScore?checklist.totalScore:'0'}}</div>
										</div>
										<div class="flex-grow-1 mgl-20">
												<div class="t-body3 font-r l-spacing42 t-line-h-20">{{ checklist && checklist.member?$t('3437',{first: checklist.member.name.first, last: checklist.member.name.last}):''}}</div>
												<div class="mgt-1">
														<span class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA right-divider position-relative">{{checklist?checklist.member.dutyName:''}}</span>
														<span class="t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA right-divider position-relative">{{checklist?checklist.member.responsibilityName:''}}</span>
												</div>
												<div class="mgt-18 d-flex justify-content-between align-items-baseline flex-grow-1 pdr-16">
														<div class="t-body4 font-rn t-color-bodyGrayA t-line-h-17">{{checklist && checklist.lastSubmitDate?$moment(checklist.lastSubmitDate).format('L'):''}} {{ checklist && checklist.lastSubmitDate?$moment(checklist.lastSubmitDate).format('HH:mm'):''}}</div>
														<div class="t-helper font-r t-color-bodyGrayB t-line-h-17">{{checklist && checklist.submissionsCount?$t('3345',{str:checklist.submissionsCount}):$t('3345',{str:0})}}</div>
												</div>
										</div>
								</div>
								<div class="divider "></div>
						</div>
						<div class="mgt-100" v-if="isNoData">		
								<img src="/images/board/no-board-data.svg" alt="" class="edm-nodata mgx-auto mgb-24" v-if="!searchOpenNodata">
									<div class="t-center t-subtitle font-m l-spacing48 t-line-h-20" v-if="!searchOpenNodata">{{$t('3443')}}</div>
									<div class="t-center t-subtitle font-m l-spacing48 t-line-h-20" v-if="contents && searchOpenNodata">{{$t('3352')}}</div>
									<div class="t-center t-body3 font-r l-spacing42 t-line-h-20 t-color-bodyGrayA mgt-8" v-if="contents && searchOpenNodata">{{$t('3353')}}</div>
								</div>
						</div>

						<div class="fab-contrainer">
								<button class="mdc-fab mdc-fab--extended bg-mainBtn"  @click="moveToQuestion" @keypress="moveToQuestion" v-if="distributionDetail.status.value != 'STOP'" tabindex="0">
										<div class="mdc-fab__ripple"></div>
										<span class="material-icons mdc-fab__icon">edit</span>
										<span class="mdc-fab__label font-r t-body2">{{$t('3346')}}</span>
								</button>
						</div>
													<infinite-loading @infinite="fetchData" :identifier="infiniteId" spinner="spiral">
															<div slot="no-more" class="mgt-16"></div>
															<div slot="no-results" class="mgt-16"></div>
													</infinite-loading>  
				</main>

		</div>
	</div>
</template>

<script>
import {MDCMenu} from '@material/menu';
import checklistApi from '@/api/checklistApi.js'
import TopAppBarDrawer from "../TopAppBarDrawer.vue";
import { topAppBarMixin } from "../../mixins/topAppBar.js";
import InfiniteLoading from 'vue-infinite-loading'
import TopAppBar from "@/components/TopAppBar.vue";
export default {
		data() {
		return {
			menuBar: null,
			detail: [],
			distributionDetail: null,
			contents:'',
			isNoData: false,
			isDrawerOpen: false,
			menuTypeTitle:this.$t('3344'),
			slectedMenuType:'ALL',
			distributionId: null,
			firstCharOfNames : localStorage.getItem('firstChar'),
			bgColorOfName : localStorage.getItem('bgColors'),
			currentPage: 1,
			totalPages: 1,
			infiniteId: +new Date(),
			showing:{'display':'block'},
			hiding:{'display':'none'},
			backFixLayer:false,
			unSolvedIndex: null,
			showHide: false,
			exists: [],
			totalElements: 0,
			searchOpenNodata:false,
			showToggle:false
		}
	},

	components: {
		TopAppBarDrawer,
		InfiniteLoading,
		TopAppBar
	},

	mixins: [topAppBarMixin],

	watch: {
		$route(to, from) {
			this.initData()
		}
	},
	
	mounted() {
		this.distributionId =  this.$route.params.postId
		const menuEls = Array.from(document.querySelectorAll('.mdc-menu'));
		menuEls.forEach((menuEl) => {
			this.menuBar = new MDCMenu(menuEl);
			const dropdownToggle = menuEl.parentElement.querySelector('.js--dropdown-toggle');
			dropdownToggle.addEventListener('click', () => {
				this.menuBar.open = !this.menuBar.open;
			});
		});
		
		this.getDetail();
		this.exist();
		//this.getComments();
	},

	methods: {
		toggleMenu(){
			this.showToggle = !this.showToggle;
		},
		openDrawer() {
			this.isDrawerOpen = true;
		},
		// Close drawer
		closeDrawer() {
			this.isDrawerOpen = false;
		},

		initData() {
			this.detail = []
			this.currentPage = 1
			this.totalPages = 1
			this.infiniteId += 1
		},


			//Alert box delete
		deleteAnswer() {
			this.$confirm({
				content: this.$t("3358"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
				accept: this.$t("3360"), // 확인
				cancel: this.$t("3359"), //'TODO-취소'
			}).then(() => {
				this.$showLoading();
				checklistApi.deleteAnswer(this.exists.id).then((response) => {
					if (response.data.data == true) {
						// this.initData();
						this.exist();
					}
					this.$hideLoading();
				}).catch((err) => {
					this.$hideLoading();
					//this.$error({content: err.errMsg}).then(() => {
				 // });
				});
			}).catch(() => {

			});
		},


		//Delete post by loggedIn user
		// deletePost() {
		//     this.$showLoading();
		//         boardApi.deletePost(this.$route.params).then((response) => {
		//             this.$hideLoading();
		//             this.goToPrevious()
		//             //this.$router.push('/socialLearning?board='+this.boardId+'&boardName='+encodeURI(this.boardName))
		//         }).catch((err) => {
		//             this.$hideLoading();
		//             this.$error({ content: err.errMsg }).then(() => {});
		//         });
		// },

		getDetail() {
			this.$showLoading();
			checklistApi.checkListDistributionDetails(this.$route.params).then((response) => {
				this.distributionDetail = response.data.data;

				this.$hideLoading();
			}).catch((err) => {
				this.$hideLoading();
				this.$error({content: err.errMsg}).then(() => {
				});
			});
		},

		fetchData($state) {
			let responseData = null
			let params = this.setParams()

			if (this.totalPages >= this.currentPage) {
				checklistApi.checkListDetails(this.distributionId, params).then((response) => {
					responseData = response.data.data
					this.totalElements = responseData.totalElements
					this.detail = this.detail.concat(responseData.content)
					if (responseData.content.length > 0) {
						let getIndex = this.detail[0].activeRespondentPaper.groups.forEach((element, index, array) => {
							if (element.response == false) {
								this.unSolvedIndex = index
							}

						})
					}
					this.currentPage++
					this.totalPages = responseData.totalPages

					if (responseData.content.length > 0) {
						$state.loaded()
					} else {
						$state.complete()
					}
					if (this.contents && responseData.content.length > 0) {
						this.searchOpenNodata = false

					} else if(this.contents && responseData.content.length <= 0){
						this.searchOpenNodata = true

					}
					if (responseData.content.length > 0) {
						this.isNoData = false

					} else {
						this.isNoData = true

					}

				}).catch((err) => {
					$state.error()
				})

			} else {
				$state.complete()
			}
		},

		setParams() {
			const params = {
				memberName: this.contents,
				sortType: this.selectedMenuType,
				page: this.currentPage,
				size: 10,
				sort: "id,desc",
			}
			return params
		},

		// Filter type(ALL,My Report)
		onSelect(type, lang) {
			this.menuTypeTitle = this.$t(lang);
			this.selectedMenuType = type;
			this.initData();
			this.showToggle = false;
		},


		searchOpen() {
			this.showing = {'display': 'none'};
			this.hiding = {'display': 'block'};
		},

		searchClose() {
			this.contents = ''
			this.initData()
			this.$router.go(this.$router.currentRoute)
			this.showing = {'display': 'block'};
			this.hiding = {'display': 'none'};
		},

		search() {
			this.initData();
			//this.getStaticData();
			this.showing = {'display': 'none'};
			this.hiding = {'display': 'block'};

		},
		// Recent Serach Suggestion
		getStoreSerach() {
			let charSearch = JSON.parse(localStorage.getItem('datas'));
			let searchResult = charSearch.includes(this.contents);
			if (searchResult === true) {
				this.storeSearch = charSearch;
			} else {
				this.storeSearch = ''
			}
		},
		askForModify() {
			this.$router.push({
				name: 'BoardModify',
				params: {boardId: this.$route.params.boardId, postId: this.$route.params.postId},
				query: this.$route.query
			})
		},
		unsolvedClick(){
			//console.log('parent')
						this.$router.push({
							name: 'CheckListQuestionTake',
							params: {postId: this.$route.params.postId},
							query: {groupIndex: this.unSolvedIndex + 1}
						})
		},
		moveToQuestion() {
			// checklistApi.answeredByUser(this.$route.params.postId).then((response) => {
			//   console.log(response.data.data)
			// debugger;
				if (this.exists && this.exists.activeRespondentPaper && this.exists.activeRespondentPaper.status === 'SOLVING') {
					this.$confirm({
						title: this.$t('3354'),
						content: this.$t("3355"),
						accept: this.$t("3357"),
						cancel: this.$t("3356"),
					}).then(() => {
						this.$router.push({
							name: 'CheckListQuestionTake',
							params: {postId: this.$route.params.postId},
							query: {groupIndex: this.unSolvedIndex + 1}
						})
					}).catch(() => {
						checklistApi.resetQuestionAnswered(this.exists.id).then((response) => {
							this.$router.push({
								name: 'CheckListQuestionTake',
								params: {postId: this.$route.params.postId}
							})
						}).catch((err) => {

						})
					})
				} else {
					this.$router.push({
						name: 'CheckListQuestionTake',
						params: {postId: this.$route.params.postId}
					})
				}
				// this.distributionDetail = response.data.data;
				// this.$hideLoading();
			// }).catch((err) => {
			//   this.$hideLoading();
			//   this.$error({content: err.errMsg}).then(() => {
			//   });
			// });

			// this.$alert({
			// 	title: this.$t('3354'),
			// 	content: this.$t("3355"),
			// 	accept: this.$t("3357"),
			// 	cancel: this.$t("3356"),
			// }).then(() => {
			// 	this.$router.push({
			// 		name: 'CheckListQuestionTake',
			// 		params: {postId:this.$route.params.postId}
			// 	})
			// }).catch(() => {
			// 		checklistApi.(this.$route.params).then((response) => {
			// 		this.distributionDetail = response.data.data;
			// 		this.$hideLoading();
			// 	}).catch((err) => {
			// 		this.$hideLoading();
			// 		this.$error({ content: err.errMsg }).then(() => {});
			// 	});
			// 	checklist/respondent/exist
			// });

		},

		goToList() {
			this.$router.push({
				name: 'CheckList',
			})
		},
		goToCommentSection(checklist) {
			this.$router.push({
				name: 'SubmittedResult',
				params: {
					postId: checklist.id,

				}
			})
		},
		exist() {
			checklistApi.answeredByUser(this.$route.params.postId).then((response) => {
				//console.log(response.data.data , ' ___')
				this.exists = response.data.data;
				if(response.data.data.activeRespondentPaper.groups){
					response.data.data.activeRespondentPaper.groups.some((value, index)=>{
						this.unSolvedIndex = index;
						return value.response === false;
					})
				}
			}).catch((err) => {
				this.$hideLoading();
				// this.$error({content: err.errMsg}).then(() => {
				// });
			});

		}
	}
}
</script>
<style scoped>

	
</style>